import { isBundledExperienceItem } from 'lib/checkout/checkoutUtils'

export function isMultiCartHotelItem(item: App.MultiCartItem): item is App.MultiCartInstantBookingLEHotelItem {
  return item.type === 'hotel'
}

export function isMultiCartBedbankHotelItem(item: App.MultiCartItem): item is App.MultiCartBedbankHotelItem {
  return item.type === 'bedbankHotel'
}

export function isMultiCartFlightItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  return item.type === 'flight'
}

export function isIncompleteReturnFlightMultiCartItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  if (!isMultiCartFlightItem(item)) return false

  const flightItem = item.item as App.Checkout.FlightItem
  return flightItem.fareType === 'return' && !flightItem.flights?.[1]?.departingDate
}

export function isDisplayableMultiCartItem(item: App.MultiCartItem): boolean {
  return !isIncompleteReturnFlightMultiCartItem(item) && !isBundledExperienceItem(item.item)
}

export function getBundledAccomExperienceTotal(items: ReadonlyArray<App.MultiCartItem>): number {
  const activeParentItemIds = new Set(
    items
      .filter(mci => mci.state === 'active')
      .map(mci => mci.item as { itemId?: string, isAccomBundle?: string })
      .filter(item => !!item.isAccomBundle)
      .map(item => item.itemId)
      .filter((id): id is string => !!id),
  )

  return items
    .filter(mci => mci.state === 'active' && isBundledExperienceItem(mci.item))
    .reduce((sum, mci) => {
      const child = mci.item as { total?: number, bundledItemIds?: Array<string> }
      const parents = child.bundledItemIds ?? []
      if (!parents.length) return sum + (child.total ?? 0)
      const presentParents = parents.filter(id => activeParentItemIds.has(id)).length
      if (!presentParents) return sum
      return sum + ((child.total ?? 0) * presentParents) / parents.length
    }, 0)
}
